// src/components/QuizOptions.js
import React from 'react';

function QuizOptions({ options, onAnswer }) {
  return (
    <div className="quiz-options">
      {options.map((option) => (
        <button key={option.id} onClick={() => onAnswer(option)}>
          {option.nombreComun}
        </button>
      ))}
    </div>
  );
}

export default QuizOptions;